import {Injectable} from '@angular/core';
import {Observable} from 'rxjs';
import {DataTablesResponse} from '../models/dataTables-response';
import {webServiceConfig} from '../config/web-service.config';
import {map} from 'rxjs/operators';
import {HttpClient} from '@angular/common/http';

@Injectable({
    providedIn: 'root'
})
export class BankAccountService {

    constructor(private http: HttpClient) {
    }


    getDatatable(dataTablesParameters): Observable<any> {
        return this.http.post<DataTablesResponse>(`${webServiceConfig.webServiceUrl}bank-accounts/datatable`, dataTablesParameters, {})
            .pipe(map(response => {
                return response;
            }));
    }

    getAll(status: any = ''): Observable<any> {
        if (status) {
            status = `?status=${status}`;
        }
        return this.http.get(`${webServiceConfig.webServiceUrl}bank-accounts${status}`).pipe(map(response => {
            return response;
        }));
    }

    getById(bankAccountId: number): Observable<any> {
        return this.http.get(`${webServiceConfig.webServiceUrl}bank-accounts/${bankAccountId}`).pipe(map(response => {
            return response;
        }));
    }

    store(bankAccount: any): Observable<any> {
        return this.http.post(`${webServiceConfig.webServiceUrl}bank-accounts`, bankAccount)
            .pipe(map(response => {
                return response;
            }));
    }

    update(bankAccount: any): Observable<any> {
        return this.http.put(`${webServiceConfig.webServiceUrl}bank-accounts/${bankAccount.id}`, bankAccount)
            .pipe(map(response => {
                return response;
            }));
    }

    delete(id: number): Observable<any> {
        return this.http.delete(`${webServiceConfig.webServiceUrl}bank-accounts/${id}`)
            .pipe(map(response => {
                return response;
            }));
    }
}
